import { BooleanInput, coerceBooleanProperty } from '@angular/cdk/coercion';
import {
  AfterViewInit,
  computed,
  Directive,
  Input,
  Output,
} from '@angular/core';
import { MultiSelect } from 'primeng/multiselect';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Directive({
  selector: '[appMultiSelectExtender]p-multiSelect',
  standalone: false,
})
/** Directive used with PrimeNG dropdown, to support server side filtering */
export class MultiSelectExtenderDirective implements AfterViewInit {
   
  @Input('appMultiSelectExtender')
  set enabled(value: BooleanInput) {
    this._enabled = coerceBooleanProperty(value);
  }
  get enabled() {
    return this._enabled;
  }
  private _enabled = true;

  @Input() filterDebounceTime = 300;

  private _onFilter = new Subject<string>();
  @Output() onFilter = this._onFilter.pipe(
    debounceTime(this.filterDebounceTime),
    distinctUntilChanged(),
  );

  constructor(private pMultiSelect: MultiSelect) {}

  ngAfterViewInit() {
    // Override primeNG this.pMultiSelect's onFilterInputChange method to support server side filtering.
    setTimeout(() => {
      if (this.enabled) {
        this.pMultiSelect.onFilterInputChange = (event) => {
          if (this._enabled) {
            this.pMultiSelect._filterValue.set(
              (<HTMLInputElement>event.target).value,
            );
          }
          this._onFilter.next(this.pMultiSelect._filterValue());
        };
        this.pMultiSelect.visibleOptions = computed(() => {
          return this.pMultiSelect.group
            ? this.pMultiSelect.flatOptions(this.pMultiSelect.options)
            : this.pMultiSelect.options || [];
        });
      }
    });
  }
}
